<template>
    <div class="whatsapp-contact-list-switcher">
        <WhatsappContactList
            :channelId="selectedChannelId"
            :channel="getSelectedChannel()"
            :show-title="false"
            allow-import
            :forbidden="isForbidden(getSelectedChannel())"
        >
            <template v-slot:left-actions>
                <div class="channel-switcher">
                    <ChannelPicker
                        :auto-select-first="false"
                        include-deleted
                        v-model="selectedChannelId"
                        :show-all-option="true"
                        :all-option-label="$t('message.allChannels')"
                        all-option-value="all"
                    />
                </div>
            </template>
        </WhatsappContactList>
    </div>
</template>
<script>
import Vue from "vue";
import WhatsappContactList from "./WhatsappContactList.vue";
import { mapGetters, mapState } from "vuex";
import { CHANNEL_API } from "../../../api/channel";
import _ from "lodash";
import ChannelPicker from "../../../components/pickers/ChannelPicker.vue";

export default Vue.extend({
    name: "WhatsappContactListSwitcher",
    components: { ChannelPicker, WhatsappContactList },
    data() {
        return {
            channels: [],
            selectedChannelId: "all",
        };
    },
    computed: {
        ...mapState({
            activeChannels: (state) =>
                state.channel.channels.filter((channel) =>
                    ["whatsapp-qr", "whatsapp-v2", "whatsapp-unipile", "whatsapp-v1", "whatsapp-business-api", "whatsapp-business-api-supsis"].includes(channel.type)
                ),
        }),
        ...mapGetters({
            isChannelVisibleForMe: "channel/isChannelVisibleForMe",
        }),
    },
    created() {
        this.channels = this.activeChannels;
    },
    methods: {
        isForbidden(channel) {
            console.log("isForbidden", { channel });
            if (!channel) return false;
            console.log("isForbidden", { channel, visibleToMe: this.isChannelVisibleForMe(channel) });
            return !this.isChannelVisibleForMe(channel);
        },
        fetchChannels() {
            CHANNEL_API.listChannels(true).then((response) => {
                this.channels = response.data.filter((channel) =>
                    ["whatsapp-qr", "whatsapp-v2", "whatsapp-unipile", "whatsapp-v1", "whatsapp-business-api", "whatsapp-business-api-supsis"].includes(channel.type)
                );
                this.channels = _.orderBy(this.channels, ["isDeleted", "name"], ["asc", "asc"]);
            });
        },
        getSelectedChannel() {
            return this.selectedChannelId === "all"
                ? null
                : this.channels.find((channel) => channel._id === this.selectedChannelId);
        },
    },
    mounted() {
        this.fetchChannels();
    },
});
</script>

<style lang="scss">
.whatsapp-contact-list-switcher {
    display: flex;
    flex-direction: column;

    .channel-switcher {
        width: 100%;
        min-width: 200px;
    }
}
</style>
